/**
 * Round value to closest (to a bigger one) divisible by to
 *
 * example:
 * value = 38, to = 15, roundTo(value, to) => 45
 * @param value
 * @param to
 */
const roundTo = (value: number, to: number) => {
    return Math.ceil(value / to) * to;
}

export { roundTo }